<template>
    <div class="container">
        <div class="top">
            <img class="logo" src="@/assets/imgs/logo.png" alt="logo">
        </div>
        <van-form @submit="onSubmit">
                <van-field
                    v-model="userphone"
                    name="userphone"
                    label="手机号"
                    type="tel"
                    placeholder="请输入手机号"
                    @blur="blurtest('userphone')"
                    @focus="focustest('userphone')"
                    class="borderBottom"
                >
                <template #button>
                    <div class="phoneRight">
                        <span class="red buttonText">{{userphoneShow && userphone!=='' ? "手机号码格式错误" : ""}}</span>
                        <span class="red buttonText" v-if="userphone!==''" @click="clearVal('userphone')">
                            <van-icon  name="clear" color="#999"/>
                        </span>
                    </div>
                </template>
                </van-field>
                <van-field
                    v-model="code"
                    name="code"
                    label="验证码"
                    placeholder="请输入验证码"
                    type="digit"
                    class="borderBottom code"
                    @blur="blurtest('code')"
                    @focus="focustest('code')"
                >
                    <template #button>
                        <div>
                            <span class="red buttonText" v-if="codeShow && code!==''">验证码错误</span>
                            <span class="line"></span>
                            <div class="rightWidth">
                                <span class="red buttonText " v-if="timeShow">{{buttonText}}</span>
                                <span class="red buttonText" v-else @click="getBindingSmsCode()">{{buttonText}}</span>
                            </div>
                        </div>
                    </template>
                </van-field>
                <van-button class="bgRed btnColor" round block native-type="submit">绑定</van-button>
         </van-form>
    </div>
</template>

<script>
import { Toast } from 'vant';
export default {
    data() {
        return {
            userphone: '',
            code: '',
            userphoneShow:false,
            codeShow:false,
            userphoneReg: /^1[3456789]\d{9}$/,
            codeReg:/^\d{6}$/,
            buttonText:'获取验证码',//获取验证码，重新获取
            timeShow:false,
        };
    },
    created(){
        document.title="绑定手机号";
        // console.log("phone",this.$store.state.token)

    },
    methods: {
         focustest(val){
            this[val+'Show']=false;
        },
        blurtest(val){
            if(this[val+'Reg'].test(this[val])){
                this[val+"Show"]=false;
            }else{
                this[val+"Show"]=true;
            }
        },
        clearVal(e){
            this[e]=""
        },
        getBindingSmsCode(){
            if(this.userphoneReg.test(this.userphone)){
                this.$https.fetchPost("Login/getBindingSmsCode",{"mobile":this.userphone},{headers:{"XX-Token":this.$store.state.token}})
                .then(result=>{
                    let data=result.data;
                    if(data.code==1){
                        this.textNum();
                    }
                    Toast(data.msg)
                })
            }else{
                Toast("请输入正确的手机号")
            }
        },
        textNum(){
            let num=60;
            this.timeShow=!this.timeShow;
            let timer=setInterval(()=>{
                if(num==0){
                    this.buttonText="重新获取";
                    this.timeShow=!this.timeShow;
                    clearInterval(timer);
                }else{
                    this.buttonText=num+"s";
                }
                num--;
            },1000)
        },
        onSubmit(values) {
            console.log(values);
            this.$https.fetchPost("Login/bindingMobile",{"mobile":values.userphone,"verification_code":values.code},{headers:{"XX-Token":this.$store.state.token}})
            .then(result=>{
                let data=result.data;
                if(data.code==1){
                    let info=this.$store.state.userInfo;
                        info.mobile=values.userphone;
                    this.$store.commit("LOGIN",info);
                    this.$router.push("/login");
                }else{
                    Toast(data.msg);
                }
            })
        },
    },
    computed:{
        // showRed(){
        //     if(this.username!=="" && this.code!==""){
        //         return true
        //     }else{
        //         return false
        //     }
        // }
    }
}
</script>

<style scoped>
    .top{
        width: 100%;
        padding: 50px 0;
        background: #f5f5f5;
    }
    .logo{
        width: 53%;
        margin: 0 auto;
    }
    .bgRed{
        width: 340px;
         color: #fff;
        /* background:linear-gradient(-270deg,rgba(243,71,64,1),rgba(251,149,138,1)); */
        position: absolute;
        bottom: 30%;
        left: 50%;
        transform: translate(-50%, 0);
    }
    .borderBottom{
        border-bottom: 1px solid #ebebeb;
    }
    .van-form{
        margin:0 15px;
        text-align: start;
    }
    .van-cell{
        padding: 14px 0;
        /* display: block; */
    }
   .van-cell /deep/ .van-cell__value {
        display: flex;
        justify-content: space-between;
        color: #333;
        position: relative;
    }
    /* .van-field--error /deep/ .van-field__control{
        color: #333;
    }
     .van-cell /deep/ .van-cell__value /deep/ .van-field__error-message{
        position: absolute;
        top: 0;
        right: 20px;
        color: #F34740;
     }
    .code.van-cell /deep/ .van-cell__value /deep/ .van-field__error-message{
        right: 70px;
     } */
      .van-cell /deep/ .van-cell__value /deep/ .van-field__body{
          width: 100%;
      }
      .van-cell /deep/ .van-cell__value /deep/ .van-field__body>input{
          font-size: 13px;
      }
    .van-cell /deep/ .van-field__label{
        width: 65px;
        font-size: 14px;
        color: #333;
    }
    .van-cell  /deep/ .van-field__control input{
        font-size: 13px;;
    }
    .phoneRight{
        height: 25px;
    }
    .buttonText{
        width: 60px;
        text-align: center;
        font-size: 12px;
    }
    .rightWidth{
        display: inline-block;
        width: 70px;
        text-align: center;
    }
    .line{
        border-left:1px solid rgba(241,240,240,1);
        margin:0 5px
    }
    .van-icon{
        top:2px;
    }
</style>



// WEBPACK FOOTER //
// src/views/login/phone.vue